import {
    ServiceGroupCreateForm,
    ServiceGroupStatus,
    ServiceGroupUpdateForm,
    ServiceGroupData,
    ServiceGroupServicesQuery,
    ServiceGroupAddServiceParams,
    ServiceGroupServiceUpdateForm,
    ServiceGroupServiceResponse,
    ServiceGroupListResponse,
    ServiceGroupResponse,
    ServiceGroupQuery,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/service-group';

export class ServiceGroupApi {
    public static async create(serviceGroup: ServiceGroupCreateForm): Promise<void> {
        await axios.post(`${BASE_URL}`, { serviceGroup });
    }

    public static async update(id: string, serviceGroup: ServiceGroupUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { serviceGroup });
    }

    public static async updateStatus(id: string, status: ServiceGroupStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { serviceGroup: { status } });
    }

    public static async getList(params?: ServiceGroupQuery): Promise<ServiceGroupListResponse> {
        const res = await axios.get(`${BASE_URL}`, { params });

        return res.data;
    }

    public static async getServiceGroup(id: string): Promise<ServiceGroupData> {
        const res = await axios.get<ServiceGroupResponse>(`${BASE_URL}/${id}`);

        return res.data.serviceGroup;
    }

    public static async getServiceList(
        id: string,
        params?: ServiceGroupServicesQuery,
    ): Promise<ServiceGroupServiceResponse> {
        const res = await axios.get(`${BASE_URL}/${id}/service`, { params });

        return res.data;
    }

    public static async addService(id: string, service: ServiceGroupAddServiceParams): Promise<void> {
        await axios.post(`${BASE_URL}/${id}/service`, { service });
    }

    public static async updateService(
        id: string,
        serviceId: string,
        service: ServiceGroupServiceUpdateForm,
    ): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/service/${serviceId}`, { service });
    }
}
